import { useState } from "react";
import { ChevronDown, ChevronUp, Clock } from "../../icons/IconCollection";
import { getOpeningMessage } from "../../utils/commanFunctions";

const StoreAccordion = ({ singleStore }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => setIsOpen(!isOpen);

  
  
   const hasValidDescriptions = Array.isArray(
    singleStore?.opening_hours?.weekdayDescriptions
  ) && singleStore.opening_hours.weekdayDescriptions.length > 0;

  // ✅ If no valid descriptions, return a simple non-toggle UI
  if (!hasValidDescriptions) {
    return (
      <div className="flex items-center gap-4 relative self-stretch w-full flex-[0_0_auto] bg-[#EAEAEA] store-accordion-card rounded-xl p-4">
        <div className="flex w-6 h-12 items-center gap-2 relative details-bottom-card-icon-div">
          <Clock className="!relative !flex-1 !grow !h-6" />
        </div>

        <div className="flex items-center justify-between gap-2 px-0 py-4 relative flex-1 grow border-b border-wwwstanfordcourtcommercury details-bottom-card-text">
          <p
            className={`relative font-secondary font-normal text-virginhotelscomthunder text-sm tracking-[0] leading-5 ${
              singleStore?.open_now ? "store-open" : "store-closed"
            }`}
          >
            {singleStore?.open_now === true ? "Open" : singleStore?.open_now === false ? "Closed" : ""}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div
      className="flex flex-col w-full cursor-pointer"
      onClick={toggleAccordion}
    >
      {/* Accordion Header */}
      <div
        className={`flex items-center gap-4 relative self-stretch w-full flex-[0_0_auto] bg-[#EAEAEA] store-accordion-card justify-start  ${
          isOpen ? "rounded-t-xl px-4 pt-4 pb-2" : "rounded-xl p-4"
        }`}
      >
        <div className="flex w-6 h-12 items-center gap-2 relative details-bottom-card-icon-div">
          <Clock className="!relative !flex-1 !grow !h-6" />
        </div>

        <div className="flex items-center justify-center gap-2 px-0 py-4 relative flex-1 grow border-b border-wwwstanfordcourtcommercury details-bottom-card-text">
          <div className="flex w-full gap-1 ">
            <p
              className={`relative mt-[-1.00px] font-secondary font-normal w-fit text-virginhotelscomthunder text-sm tracking-[0] leading-5 ${
                singleStore?.open_now ? "store-open" : "store-closed"
              }`}
            >
              {singleStore?.open_now === true ? "Open" : singleStore?.open_now === false ? "Closed" : ""}
            </p>
            {!isOpen &&
  ((singleStore?.open_now === false) ||
    (singleStore?.open_now === false &&
      singleStore.opening_hours?.weekdayDescriptions?.length > 0)) && (
    <span className="relative mt-[-1.00px] font-secondary font-normal text-virginhotelscomthunder text-xl tracking-[0] leading-5">
      •
    </span>
  )}


            <p
              className={`relative mt-[-1.00px] font-secondary font-normal text-virginhotelscomthunder text-sm tracking-[0] leading-5`}
            >
              {!isOpen &&
                !singleStore?.open_now &&
                typeof singleStore.opening_hours === "object" &&
                singleStore.opening_hours?.weekdayDescriptions?.length > 0 &&
                getOpeningMessage(singleStore.opening_hours)}
            </p>
          </div>
          {isOpen ? <ChevronUp /> : <ChevronDown />}
        </div>
      </div>

      {/* Accordion Content */}
      {isOpen && (
        <div className=" bg-[#EAEAEA] store-accordion-card rounded-b-xl px-4 pb-4">
          <div className="flex items-center justify-center gap-2 px-0 py-4 relative flex-1 grow border-b border-wwwstanfordcourtcommercury details-bottom-card-text">
            <div className="relative flex-1 font-secondary font-normal text-virginhotelscomthunder text-sm tracking-[0] leading-5">
              {Array.isArray(singleStore?.opening_hours?.weekdayDescriptions) &&
                singleStore.opening_hours.weekdayDescriptions.map(
                  (desc, idx) => (
                    <p
                      key={idx}
                      className="pl-10 mb-[6px] relative flex-1 mt-[-1.00px] font-secondary font-normal text-virginhotelscomthunder text-sm tracking-[0] leading-5"
                    >
                      {desc}
                    </p>
                  )
                )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StoreAccordion;
